/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMeasurement, PhrMeasurementFromJSON, PhrMeasurementFromJSONTyped, PhrMeasurementToJSON } from "./";

export const PhrAnemiaTypename = "PhrAnemia" as const;

/**
 *
 * @export
 * @interface PhrAnemia
 */
export interface PhrAnemia {
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrAnemia
   */
  hematocrit?: PhrMeasurement;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrAnemia
   */
  hemoglobin?: PhrMeasurement;
  /**
   *
   * @type {string}
   * @memberof PhrAnemia
   */
  reason?: string;
  /**
   *
   * @type {PhrMeasurement}
   * @memberof PhrAnemia
   */
  redBlood?: PhrMeasurement;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrAnemia
   */
  readonly __typename?: string;
}

export function PhrAnemiaFromJSON(json: any): PhrAnemia {
  return PhrAnemiaFromJSONTyped(json, false);
}

export function PhrAnemiaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrAnemia {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrAnemiaTypename,

    hematocrit: !exists(json, "hematocrit") ? undefined : PhrMeasurementFromJSON(json["hematocrit"]),
    hemoglobin: !exists(json, "hemoglobin") ? undefined : PhrMeasurementFromJSON(json["hemoglobin"]),
    reason: !exists(json, "reason") ? undefined : json["reason"],
    redBlood: !exists(json, "red_blood") ? undefined : PhrMeasurementFromJSON(json["red_blood"]),
  };
}

export function PhrAnemiaToJSON(object?: PhrAnemia | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    hematocrit: PhrMeasurementToJSON(value.hematocrit),
    hemoglobin: PhrMeasurementToJSON(value.hemoglobin),
    reason: value.reason,
    red_blood: PhrMeasurementToJSON(value.redBlood),
  };
}
